import { CSSProperties, SVGProps } from 'react';

import { COLORS } from '../../../lib';

interface ChevronDownProps extends SVGProps<SVGSVGElement> {
  color?: CSSProperties['color'];
  isActive?: boolean;
}

export const ChevronDown = ({
  color,
  isActive,
  ...props
}: ChevronDownProps) => {
  const fill = color ?? COLORS['base-100'];
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: isActive ? 'rotate(-180deg)' : 'rotate(0deg)',
        transition: 'transform .3s ease-in-out',
      }}
      {...props}
    >
      <g id="ic_16/Down arrow">
        <path
          id="Icon"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5635 8.54955C17.9232 8.94895 17.9232 9.5965 17.5635 9.9959L12.6512 15.4504C12.2915 15.8498 11.7083 15.8498 11.3486 15.4504L6.43636 9.9959C6.07666 9.5965 6.07666 8.94895 6.43636 8.54955C6.79605 8.15015 7.37923 8.15015 7.73892 8.54955L11.9999 13.2809L16.2609 8.54955C16.6206 8.15015 17.2038 8.15015 17.5635 8.54955Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
